(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-tabs.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-tabs.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.rounds.views.RoundsTabs = Backbone.Marionette.CollectionView.extend({
    tagName: 'ul',
    className: 'rounds-tabs-ul tab tab-inverted',
    id: 'roundsTabs',
    childView: svs.app.productStartPage.rounds.views.RoundsTabsItem,
    childViewOptions: function(model, i) {
      return {
        groupName: model.get('group'),
        childIndex: i
      };
    },
    initialize: function() {
      var self = this;
      this.listenTo(this.collection, 'change:active', function(
        activeModel,
        state
      ) {
        if (state) {
          self.collection.each(function(currentModel) {
            if (activeModel.cid !== currentModel.cid) {
              currentModel.set({
                active: false
              });
            }
          });
        }
      });
    },
    template: function() {
      return '';
    }
  });
})(Backbone, _, svs);

 })(window);